var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8161 7.93269L6.63503 0.673077C6.39181 0.252404 5.96328 0 5.5 0C5.03672 0 4.60819 0.252404 4.36497 0.661058L0.18389 7.93269C-0.059331 8.35337 -0.059331 8.87019 0.172308 9.30289C0.403947 9.73558 0.832478 10 1.31892 10H9.68108C10.1559 10 10.5845 9.73558 10.8277 9.30289C11.0593 8.87019 11.0593 8.35337 10.8161 7.93269ZM4.96723 3.46154C4.96723 3.16106 5.21045 2.90865 5.5 2.90865C5.78955 2.90865 6.03277 3.16106 6.03277 3.46154V5.75721C6.03277 6.05769 5.78955 6.3101 5.5 6.3101C5.21045 6.3101 4.96723 6.05769 4.96723 5.75721V3.46154ZM5.5 8.23317C5.14096 8.23317 4.85141 7.93269 4.85141 7.5601C4.85141 7.1875 5.14096 6.88702 5.5 6.88702C5.85904 6.88702 6.14859 7.1875 6.14859 7.5601C6.14859 7.93269 5.85904 8.23317 5.5 8.23317Z",
    fill: "#820404"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAlert);
export default __webpack_public_path__ + "static/media/warning-alert.b569fb82b11be332355fcfe3867606d8.svg";
export { ForwardRef as ReactComponent };